type AwardBadgesProps = {
  awardBadges?: React.ReactNode[];
  prefix?: string;
};

export const AwardBadges = ({ awardBadges = [], prefix = "" }: AwardBadgesProps) =>
  awardBadges.map((awardImage, index) => {
    const src: string = (awardImage as React.ReactElement)?.props?.src ?? 'no-src';
    const key = `${prefix}-award-image-${index}-${src}`;

    return (
      <div key={key} data-key={key} className="flex flex-col justify-center items-center last:hidden last:md:block">
        {awardImage}
      </div>
    );
  });
